import { Directive } from '@angular/core';
import { AbstractControl, FormGroup, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[capAtLeastOneValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: AtLeastOneValidatorDirective,
      multi: true
    }
  ]
})
export class AtLeastOneValidatorDirective implements Validator {
  validate(c: AbstractControl): ValidationErrors | null {
    const controls = (c as FormGroup).controls;
    const controlNames = Object.keys(controls);
    const count = controlNames.filter((name) => !!controls[name].value).length;
    return count > 0 ? null : { required: true };
  }
}
